import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ArchiveFilterModalState {
  isArchiveFilterModalOpened: boolean;
}

interface ToggleViewPayload {
  isArchiveFilterModalOpened: boolean;
}

export const initialState: ArchiveFilterModalState = {
  isArchiveFilterModalOpened: false
};

const archiveFilterModalSlice = createSlice({
  name: 'archiveFilterModal',
  initialState,
  reducers: {
    toggleView(state, action: PayloadAction<ToggleViewPayload>) {
      state.isArchiveFilterModalOpened = action.payload.isArchiveFilterModalOpened;
    }
  }
});

export const {
  toggleView
} = archiveFilterModalSlice.actions;

export default archiveFilterModalSlice.reducer;
